import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getContentCompletionData, getUserName, usePathway } from '../../../hooks';
import { IBLSpinLoader, PathwayItemComponent } from '../../../components';
import { useTranslation } from 'react-i18next';

export const PathwayViewContent = ({ pathwayID, username }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [pathwayDetailData, pathwayDetailDataLoaded] = usePathway(
    pathwayID,
    username,
    searchParams.has("is-assigned-pathway")
  );
  const { t } = useTranslation('library');

  const hasData = pathwayDetailData && pathwayDetailData.length > 0;
  const pathwayData = hasData ? pathwayDetailData[0] : {};

  const handleRemoveItemClick = () => {
    return;
  };

  const [completionData, setCompletionData] = useState({
    completion_percentage:null,
    count:0
  })

  const handleCompletionDataFetch = async () =>{
    getContentCompletionData({
      pathway_uuid: pathwayID,
      username:getUserName()
    }, 'pathway', (data)=>{
      setCompletionData({
        completion_percentage: Math.floor(data.completion_percentage),
        count: data?.count
      })
    })
  }

  useEffect(() => {
    if(pathwayDetailDataLoaded && pathwayData){
      handleCompletionDataFetch()
    }
  }, [pathwayDetailDataLoaded, pathwayData]);

  if (!pathwayDetailDataLoaded) {
    return <IBLSpinLoader size={40} containerHeight="150px" />;
  }

  return (
    <div className="pathway">
      <div className="div-block-110">
        <div className="pathway_div">
          <div className="div-block-121">
            {
              completionData?.completion_percentage ? (
                  <div className="content-progress-bar-block-container">
                    <div className="w-layout-vflex content-progress-bar-block full-floating">
                      <div className="w-layout-hflex content-progress-bar-top-block font-bigger">
                        <div className="w-layout-hflex flex-block-67"><img
                          src="/images/circle-check-big.svg"
                          loading="lazy" alt="" className="image-240" />
                          <div className="content-progress-bar-title">Progress</div>
                        </div>
                        <div className="content-progress-bar-percentage">{completionData?.completion_percentage}%</div>
                      </div>
                      <div className="content-progress-bar-slider-block more-height">
                        <div className="content-progress-bar-slider-percentage-block" style={{
                          width: `${completionData?.completion_percentage}%`
                        }}></div>
                      </div>
                    </div>
                  </div>
                ) :
                <></>
            }
          </div>
          <div className="text-block-58">
            {
              <>
                <Link className="w_link" to="#">
                  {pathwayData?.name}{' '}
                </Link>
                &gt;
                <Link className="w_link" to="#">
                  {' '}
                  Pathway
                </Link>
              </>
            }
          </div>
          <div className="div-block-75">
            <div className="p_header">
              <div className="text-block-39 wide p_t wt">
                {pathwayData?.name}
                <strong></strong>
              </div>
              {pathwayDetailDataLoaded && (
                <div className="unit-wide-description people profile_description p_t wto">
                  {`${pathwayData?.path?.length} ${t('Items')}`}
                  <span className="dash"></span> <span className="dash"></span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="p_about">
          <div className="text-block-57">
            {<>{pathwayData?.data?.description}</>}
          </div>
        </div>
      </div>
      <div className="p_outline">
        {pathwayData?.path?.map((data, index) => (
          <PathwayItemComponent
            key={index}
            data={data}
            index={index}
            handleRemoveItemClick={handleRemoveItemClick}
            enableOptions={false}
          />
        ))}
      </div>
    </div>
  );
};
